export enum DirectionFieldsEnum {
  Doctors = 1,
  Analizes,
  Examination
}
